<div
    *ngIf="!creative"
    class="import-area">
    <div
        class="drag-and-drop-area ui-scrollbar"
        [ngClass]="{ 'drag-over': isDragOver }"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <div class="hint">
            Drag and drop a PSD file to upload it <br />or select it from your computer
        </div>
        <ui-button
            text="SELECT PSD FILE"
            type="primary"
            svgIcon="upload-file"
            (click)="psdFileInput.click()"
            data-test-id="import-psd">
        </ui-button>
    </div>

    <div class="note">
        Please note that artboards cannot be larger than 5000x5000px, and individual images have a size
        limitation of 6MB. You can find more details in
        <a
            href="https://support.bannerflow.com/en/articles/7234607-photoshop-psd-import"
            target="_blank"
            >this article</a
        >.
    </div>
</div>

<input
    #psdFileInput
    id="psd-file-input"
    name="psdFileInput"
    type="file"
    accept=".psd"
    style="position: absolute; width: 0; visibility: hidden"
    data-test-id="psd-file-input"
    (change)="onFileChange(psdFileInput)" />

<div
    class="preview-wrapper"
    #creativePreview>
    <div
        *ngIf="creative"
        class="preview">
        <div
            class="creative"
            *ngIf="zoomValue()"
            [style.width.px]="creative.size.width * (zoomValue() / 100)"
            [style.height.px]="creative.size.height * (zoomValue() / 100)">
            <div class="creative__size">{{ creative.size.width }} × {{ creative.size.height }}</div>
            <div class="creative__outlet">
                <studio-creative
                    [creative]="creative"
                    [size]="creative.size"
                    [renderOnInit]="true"
                    [showTargetUrl]="false">
                </studio-creative>
            </div>
        </div>
    </div>
</div>

<ui-dialog-buttons
    class="actions"
    align="right">
    <ui-button
        id="cancel-button"
        text="Cancel"
        (click)="cancel()">
    </ui-button>
    <ui-button
        id="interaction-save-psd-creative"
        text="Add size"
        type="primary"
        data-test-id="save-psd-creative"
        (click)="saveCreative()"
        [loading]="isSaving"
        [disabled]="isSaving || !creative">
    </ui-button>
</ui-dialog-buttons>
